<template>
  <div class="import-modals">
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão do distribuidor"
      message="Tem certeza que deseja excluir este distribuidor?"
    />
  </div>
</template>

<script>
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import DistributorActions from './DistributorActions';

export default {
  name: 'distributor-imports',
  mixins: [DistributorActions],
  components: {
    ConfirmationModal,
  },
};
</script>
